// Tiny in-memory cache so page transitions render instantly from last-known data
const store = new Map();
export const getCache = (k) => store.get(k);
export const setCache = (k, v) => { store.set(k, v); return v; };
export const clearCache = (k) => store.delete(k);
